import React, { useState, useEffect } from "react";
import { format, parseISO, formatISO, endOfDay } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
let process = {
  env: {}
};
const Transactions = _ref => {
  var _memberData$balances$;
  let {
    navigate
  } = _ref;
  // const navigate = switchState;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [memberData, setMemberData] = useState(JSON.parse(localStorage.getItem("memberData")));
  const [memberName, setMemberName] = useState("");
  const navigateToHistory = () => {
    navigate("/history");
  };
  let memberId = localStorage.getItem("memberId");
  let jwtToken = localStorage.getItem("jwtToken");
  const [tierName, setTierName] = useState(null);
  const [memberBits, setMemberBits] = useState(null);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  let parsedDate = parseISO(memberData.tier_data[0].tier_end_date);
  let memberTillreadableDate = "";
  memberTillreadableDate = format(parsedDate, "MMMM yyyy");
  // console.log(memberData);

  let pointsExpirationArray = memberData.points_expiration;
  let pointsExpiring = 0;
  let todayMonthYear = format(endOfDay(new Date()), "MMMM yyyy");

  // let todayMonthYear = 'August 2027';
  // console.log(todayMonthYear);

  pointsExpirationArray.forEach(elem => {
    let elemsMonthYear = format(elem.expiration_date, "MMMM yyyy");
    // console.log(elem);
    if (todayMonthYear == elemsMonthYear) {
      pointsExpiring += elem.points;
    }
  });
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  useEffect(() => {
    let isMounted = true; // Track if the component is still mounted
    setMemberName(localStorage.getItem("memberName"));
    // Simulating an API call
    const getMemberData = async () => {
      const url = hostSrc + "/bolapi/v1/members/data/".concat(memberId, "/");
      const headers = headerConfig;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        const data = await response.json();
        if (isMounted) {
          // Only update state if component is still mounted
          setMemberData(data.data); // Directly set the data part
          localStorage.setItem("memberData", JSON.stringify(data.data));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    const getTierNamesData = async () => {
      const url = hostSrc + "/bolapi/v1/tier-classes/1/tier-level/?page_size=100/";
      const headers = headerConfig;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        const data = await response.json();
        let tierNamesData = data;
        if (isMounted) {
          // Only proceed if component is still mounted
          let memberTier = memberData.tier_data[0].tier_code_id;
          tierNamesData.forEach(element => {
            if (element.tier_code === memberTier) {
              setTierName(element.name);
            }
          });
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    const getPointsHistory = async () => {
      const url = hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&points_only=Y&bit_type=PURCHASE,PAYMENT_WITH_POINTS,REVERSAL,ENROL,EXPIRATION,THIRD_PARTY_REWARD,QRCODE_REWARD&page_size=5&status=SUCCESS");
      const headers = headerConfig;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        const data = await response.json();
        if (isMounted) {
          // Only update state if component is still mounted
          setMemberBits(data);
          setSkeletonLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        if (isMounted) {
          setMemberBits(null);
        }
      }
    };
    getMemberData();
    getTierNamesData();
    getPointsHistory();
    scrollToTop();
    return () => {
      isMounted = false; // Cleanup function to prevent state update on unmounted component
    };
  }, [memberId]); // Add `memberId` as a dependency to prevent stale data

  return /*#__PURE__*/React.createElement("div", {
    className: "transactions-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "background-logo-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "middle-vertical-image"
  }, /*#__PURE__*/React.createElement("img", {
    className: "img-pulse-logo",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/pulse-rewards-logo.png"
  })), /*#__PURE__*/React.createElement("div", {
    className: "membership-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name-expiry-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name-member-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, memberName ? memberName : ""), /*#__PURE__*/React.createElement("div", {
    className: "member-till"
  }, "Member till ", memberTillreadableDate)), /*#__PURE__*/React.createElement("div", {
    className: "point-and-expiry-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement("img", {
    className: "coin-logo",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/EarningCoins/PulseCoin.png"
  }), memberData ? (memberData === null || memberData === void 0 ? void 0 : memberData.balances.length) > 0 ? Math.round(memberData === null || memberData === void 0 || (_memberData$balances$ = memberData.balances[0]) === null || _memberData$balances$ === void 0 ? void 0 : _memberData$balances$.balance) : "0" : "0"))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "5px",
      display: "flex",
      fontSize: "12px",
      color: "#A9C4CF"
    }
  }, "Member Id:\xA0", /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: "600",
      color: "white"
    }
  }, memberData ? memberData === null || memberData === void 0 ? void 0 : memberData.member_id : "")), /*#__PURE__*/React.createElement("div", {
    className: "annual-plan"
  }, /*#__PURE__*/React.createElement("div", {
    className: "plan-name"
  }, "ANNUAL PLAN"), /*#__PURE__*/React.createElement("div", {
    className: "membership-name"
  }, tierName, " member")))), /*#__PURE__*/React.createElement("div", {
    className: "spend-points-mid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "points-expiring"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Points expiring by tomorrow"), /*#__PURE__*/React.createElement("div", {
    className: "points-contain"
  }, /*#__PURE__*/React.createElement("img", {
    className: "coin-logo",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/EarningCoins/PulseCoin.png"
  }), pointsExpiring), /*#__PURE__*/React.createElement("div", {
    className: "spend-points"
  }, "Spend Points"))), skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "350px",
      margin: "auto",
      padding: "20px 0"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 40,
    width: 350,
    borderRadius: 10,
    count: 5,
    style: {
      opacity: "0.2",
      marginBottom: "10px"
    }
  })) : /*#__PURE__*/React.createElement("div", {
    className: "points-history"
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading"
  }, "Points ", /*#__PURE__*/React.createElement("span", {
    className: "golden"
  }, "history"), " "), memberBits.length > 0 ? /*#__PURE__*/React.createElement("div", null, memberBits.map(memberBit => {
    var _memberBit$loyalty_ba, _memberBit$loyalty_ba2, _memberBit$loyalty_ba3, _memberBit$loyalty_ba4;
    return /*#__PURE__*/React.createElement("div", {
      className: "table"
    }, (memberBit === null || memberBit === void 0 ? void 0 : memberBit.loyalty_balances) != null ? /*#__PURE__*/React.createElement("div", {
      className: "details"
    }, /*#__PURE__*/React.createElement("img", {
      className: "points-logo",
      src: memberBit ? memberBit === null || memberBit === void 0 ? void 0 : memberBit.sponsor_logo : ""
    }), /*#__PURE__*/React.createElement("div", {
      className: "retail-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "retail-name"
    }, memberBit ? memberBit === null || memberBit === void 0 ? void 0 : memberBit.sponsor_name : "", " "), /*#__PURE__*/React.createElement("div", {
      className: "points-valid"
    }, (memberBit === null || memberBit === void 0 ? void 0 : memberBit.h_bit_source_generated_id) > 0 ? "".concat(memberBit === null || memberBit === void 0 ? void 0 : memberBit.h_bit_source_generated_id, "\u30FB").concat(new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    }).format(new Date(memberBit === null || memberBit === void 0 ? void 0 : memberBit.h_bit_date))) : "")), /*#__PURE__*/React.createElement("div", {
      className: "points-gained"
    }, /*#__PURE__*/React.createElement("div", {
      className: "points-plus"
    }, memberBit && memberBit !== null && memberBit !== void 0 && (_memberBit$loyalty_ba = memberBit.loyalty_balances[0]) !== null && _memberBit$loyalty_ba !== void 0 && _memberBit$loyalty_ba.rewarded ? "+".concat(memberBit === null || memberBit === void 0 || (_memberBit$loyalty_ba2 = memberBit.loyalty_balances[0]) === null || _memberBit$loyalty_ba2 === void 0 ? void 0 : _memberBit$loyalty_ba2.rewarded) : ""), /*#__PURE__*/React.createElement("div", {
      className: "points-plus",
      style: {
        color: "white"
      }
    }, memberBit && memberBit !== null && memberBit !== void 0 && (_memberBit$loyalty_ba3 = memberBit.loyalty_balances[0]) !== null && _memberBit$loyalty_ba3 !== void 0 && _memberBit$loyalty_ba3.redeemed ? "-".concat(memberBit === null || memberBit === void 0 || (_memberBit$loyalty_ba4 = memberBit.loyalty_balances[0]) === null || _memberBit$loyalty_ba4 === void 0 ? void 0 : _memberBit$loyalty_ba4.redeemed) : ""), /*#__PURE__*/React.createElement("div", {
      className: "points-expiry"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "details"
    }, /*#__PURE__*/React.createElement("img", {
      className: "points-logo",
      src: memberBit ? memberBit === null || memberBit === void 0 ? void 0 : memberBit.sponsor_logo : ""
    }), /*#__PURE__*/React.createElement("div", {
      className: "retail-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "retail-name"
    }, memberBit ? memberBit === null || memberBit === void 0 ? void 0 : memberBit.sponsor_name : "", " "), /*#__PURE__*/React.createElement("div", {
      className: "points-valid"
    }, memberBit !== null && memberBit !== void 0 && memberBit.h_bit_source_generated_id ? "".concat(memberBit === null || memberBit === void 0 ? void 0 : memberBit.h_bit_source_generated_id, "\u30FB").concat(new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    }).format(new Date(memberBit === null || memberBit === void 0 ? void 0 : memberBit.h_bit_date))) : "")), /*#__PURE__*/React.createElement("div", {
      className: "points-gained"
    }, /*#__PURE__*/React.createElement("div", {
      className: "points-plus"
    }))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "view-transactions"
  }, /*#__PURE__*/React.createElement("span", {
    className: "button",
    onClick: navigateToHistory
  }, "View all transactions", " "), /*#__PURE__*/React.createElement("img", {
    className: "transactions-logo",
    src: "https://d3hc1c528irei0.cloudfront.net/ui/rightarrow.png",
    onClick: navigateToHistory
  }))) :
  /*#__PURE__*/
  // memberBits.length > 0 ? (
  //     memberBits.map(memberBit => (
  //         <div className='table'>
  //             {memberBit?.loyalty_balances != null ? (
  //                 <div className='details'>
  //                     <img className='points-logo' src={memberBit ? memberBit.sponsor_logo : ''}></img>
  //                     <div className='retail-section'>
  //                         <div className='retail-name'>{memberBit ? memberBit.sponsor_name : ''} </div>
  //                         <div className='points-valid'>{(memberBit  && memberBit.lines?.length > 0 ) ? `${memberBit.lines?.length} items purchased・13 Aug 2024`  : ''}</div>
  //                     </div>
  //                     <div className='points-gained'>
  //                         <div className='points-plus'>{(memberBit &&  memberBit?.loyalty_balances[0]?.rewarded) ? `+${memberBit?.loyalty_balances[0]?.rewarded}` : '' }</div>
  //                         <div className='points-plus'>{(memberBit &&  memberBit?.loyalty_balances[0]?.redeemed) ? `-${memberBit?.loyalty_balances[0]?.redeemed}` : '' }</div>
  //                         {/* <div className='points-plus'>+30</div> */}
  //                         <div className='points-expiry'></div>
  //                     </div>
  //                 </div>
  //             ): (
  //                 <div className='details'>
  //                     <img className='points-logo' src={memberBit ? memberBit.sponsor_logo : ''}></img>
  //                     <div className='retail-section'>
  //                         <div className='retail-name'>{memberBit ? memberBit.sponsor_name : ''} </div>
  //                         <div className='points-valid'>{(memberBit  && memberBit.lines?.length > 0 ) ? `${memberBit.lines?.length} items purchased・13 Aug 2024`  : ''}</div>
  //                     </div>
  //                     <div className='points-gained'>
  //                         <div className='points-plus'></div>
  //                     </div>
  //                 </div>
  //             )}
  //         </div>
  //     ))
  // ):(
  React.createElement("div", {
    style: {
      padding: "150px 0px 200px",
      width: "165px",
      margin: "auto"
    }
  }, "No transactions found")
  // )
  ));
};
export { Transactions };